// extracted by mini-css-extract-plugin
module.exports = {"list":"summary_list_3q-T_","sublist":"summary_sublist_3PkfK"};